var styles = {"container":"styles-module_container__k1fWd","item":"styles-module_item__krUd9","heading":"styles-module_heading__9e3UP","value":"styles-module_value__kWhih","right":"styles-module_right__m1REI","link":"styles-module_link__MsAVn"};

export { styles as default };
//# sourceMappingURL=styles.module.css.js.map
